import { useSelector } from 'react-redux';
import { SravniIdentityClientsSubscriptionInfo } from 'src/__generated__/news/Api';

import { IPublicUser } from '@sravni/types/lib/auth';

import {
  getDidUserSubscribe,
  getFingerprint,
  getIsSubscribing,
  getIsSubscriptionPopupVisible,
  getIsUserLogged,
  getUser,
  getUserSubscriptions,
} from '../selectors/users';

export function useUser(): IPublicUser | null {
  return useSelector(getUser);
}

export function useIsUserLogged(): boolean {
  return useSelector(getIsUserLogged);
}

export const useUserSubscriptions = (): SravniIdentityClientsSubscriptionInfo['types'] =>
  useSelector(getUserSubscriptions);

export const useIsSubscribing = (): boolean => useSelector(getIsSubscribing);
export const useDidUserSubscribe = (): boolean => useSelector(getDidUserSubscribe);
export const useIsSubscriptionPopupVisible = (): boolean => useSelector(getIsSubscriptionPopupVisible);

export const useFingerprint = (): string => useSelector(getFingerprint);
